type ComponentImportMap = {
  imports: Record<string, string>
}

const COMPONENT_IMPORT_MAP_ID = "mvt-component-import-map"
const DEFAULT_IMPORTS: Record<string, string> = {
  vue: "https://esm.sh/vue@3.4.0"
}

const appImports = (componentImportMap?: ComponentImportMap | null) => {
  // Must match backend ARTIFACT_BASE_URL so @movement/* resolves to the artifacts Rails writes.
  const artifactBaseUrl = (process.env.VUE_APP_ARTIFACT_BASE_URL || "").replace(
    /\/$/,
    ""
  )

  return {
    ...DEFAULT_IMPORTS,
    ...(artifactBaseUrl
      ? { "@movement/": `${artifactBaseUrl}/movement/` }
      : {}),
    ...(componentImportMap?.imports || {})
  }
}

const installImportMap = (imports: Record<string, string>) => {
  const existing = document.querySelector<HTMLScriptElement>(
    `#${COMPONENT_IMPORT_MAP_ID}`
  )
  if (existing) return false

  const script = document.createElement("script")

  script.id = COMPONENT_IMPORT_MAP_ID
  script.type = "importmap"
  script.textContent = JSON.stringify({ imports })
  document.head.appendChild(script)

  return true
}

const installAppImportMap = (componentImportMap?: ComponentImportMap | null) =>
  installImportMap(appImports(componentImportMap))

export { installAppImportMap }
